
import MobOverview from '@/rebuild/materials/shared/esg/mobile/MobOverview.vue';
import MobFull from '@/rebuild/materials/shared/esg/mobile/MobFull.vue';
import Full from '@rebuild/materials/shared/esg/FullIndex.vue';

export const componentMap = {
	'mob-overview': MobOverview,
	'mob-full': MobFull,
	full: Full
}; 